<script setup lang="ts">
import { CircleCheck, CircleHelp } from 'lucide-vue-next'

// A quiz question with the right answer picked
const { t } = useI18n()

const answers = [
  { key: 'answer_correct', correct: true },
  { key: 'answer_fee', correct: false },
  { key: 'answer_tax', correct: false }
] as const
</script>

<template>
  <div class="relative w-[21rem] select-none" aria-hidden="true">
    <div class="HeroIllustrationCard">
      <div class="flex items-center gap-3">
        <span class="grid size-11 shrink-0 place-items-center rounded-xl bg-blue-600 text-white">
          <CircleHelp class="size-5" />
        </span>
        <div>
          <div class="text-xs font-semibold text-gray-500">{{ t('widget.hero_banner.illustration.quiz.progress') }}</div>
          <div class="font-serif text-base font-bold leading-snug">{{ t('widget.hero_banner.illustration.quiz.question') }}</div>
        </div>
      </div>

      <ul class="mt-4 space-y-1.5">
        <li
          v-for="answer in answers"
          :key="answer.key"
          class="flex items-center gap-3 rounded-xl px-3 py-2 text-sm font-semibold"
          :class="answer.correct ? 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200' : 'bg-blue-50'"
        >
          <CircleCheck v-if="answer.correct" class="size-4 shrink-0" />
          <span v-else class="size-4 shrink-0 rounded-full border-2 border-blue-200" />
          {{ t(`widget.hero_banner.illustration.quiz.${answer.key}`) }}
        </li>
      </ul>
    </div>

    <div class="HeroIllustrationBadge -bottom-4 -left-8">
      {{ t('widget.hero_banner.illustration.quiz.badge') }}
    </div>
  </div>
</template>
